import Link from 'next/link';

// Component
import PriceContainer from 'components/PriceContainer';
import CourseOrganizerImage from 'components/CourseDescription/CourseOrganizerImage';
import Button from 'components/Button';
import { BUTTON_TYPE } from 'constants/button';
import { SubHeading, TextBody } from 'components/Typography/General';
import { FONT_TYPES } from 'variables/font_groups';
import { isMobile } from 'react-device-detect';
import { trackCtaClick, trackSelectContent } from 'lib/analytics';

const RecommendedProducts = (props) => {
  const { itemId, picture, provider, title, description, discount, price, slug } = props;

  return (
    <div className="card-horizontal description-recomended">
      <div className="course-image-container">
        <img src={picture ? picture : '/dummy-img-card.jpeg'} className="course-image" alt="course image"></img>
      </div>
      <div className="description-recomended__details">
        <div>
          <CourseOrganizerImage courseOrganizer={provider} />
          <SubHeading variety={3} className="title-2">
            {title}
          </SubHeading>
        </div>
        <TextBody
          variety={isMobile ? 3 : 4}
          className="description"
          dangerouslySetInnerHTML={{ __html: description }}
        ></TextBody>
        <div className="informations">
          <div className="author">
            <TextBody variety={4}>{provider?.name}</TextBody>
          </div>
          {/* if discount not available or 0, show the real price. Else, show the discounted price with the actual price */}
          <PriceContainer
            variableDiscount={[parseFloat(discount)]}
            variablePrice={[parseFloat(price)]}
            courseOrganizer={provider.code}
            isLarge
          />
        </div>
      </div>
      <Link href={`/products/${slug}`}>
        <Button
          variety={isMobile ? 3 : 4}
          fontType={FONT_TYPES.textBody}
          type={BUTTON_TYPE.secondary}
          className="button-information"
          onClick={() => {
            trackSelectContent({
              page_type: 'product_detail',
              item_id: itemId,
              item_name: title,
              item_category: provider?.name || 'unknown',
              list_name: 'products',
            });
            trackCtaClick({
              page_type: 'product_detail',
              cta_label: 'open_product_detail',
              location: 'recommended_products_section',
              course_id: itemId,
            });
          }}
        >
          More Information
        </Button>
      </Link>
    </div>
  );
};

export default RecommendedProducts;
